var map = {
	"./a-dead-djinn-in-cairo.png": "fbe1",
	"./a-master-of-djinn.png": "52d8",
	"./ace-of-spades.png": "c9c3",
	"./adien-thomas.png": "3182",
	"./adulthood-rites.png": "4b90",
	"./after-atlas.png": "4837",
	"./akata-witch.png": "8695",
	"./akwaeke-emezi.png": "26c7",
	"./alexis-henderson.png": "aa40",
	"./alice-oseman.png": "5081",
	"./all-systems-red.png": "e456",
	"./allegedly.png": "d7ee",
	"./almond.png": "850f",
	"./amari-and-the-night-brothers.png": "516b",
	"./an-unkindness-of-ghosts.png": "e3b0",
	"./angie-thomas.png": "12c7",
	"./annie-bot.png": "c6ce",
	"./artemis.png": "3315",
	"./artificial-condition.png": "0381",
	"./ashley-woodfolk.png": "5e6c",
	"./atlas-alone.png": "bbbd",
	"./axie-oh.png": "2de1",
	"./babel.png": "f32f",
	"./bb-alston.png": "d82a",
	"./before-after-alone.png": "0408",
	"./before-mars.png": "da8d",
	"./binti-home.png": "754d",
	"./binti-night-masquerade.png": "36a8",
	"./binti.png": "e82a",
	"./bitter.png": "d0d4",
	"./black-sun.png": "8938",
	"./blackout.png": "7227",
	"./blood-over-bright-haven.png": "c07f",
	"./bloodchild-and-other-stories.png": "73c0",
	"./boleyn-traitor.png": "f6b9",
	"./born-a-crime.png": "8fd9",
	"./boyfriend-material.png": "d831",
	"./brit-bennett.png": "349a",
	"./cadwell-turnbull.png": "aeea",
	"./camryn-garrett.png": "8bf7",
	"./caste-the-origins-of-our-discontents.png": "3feb",
	"./chain-gang-all-stars.png": "616b",
	"./chesya-burke.png": "dd24",
	"./children-of-blood-and-bone.png": "7d3f",
	"./cho-nam-joo.png": "05e6",
	"./cinderella-is-dead.png": "25cc",
	"./clays-ark.png": "dc67",
	"./colson-whitehead.png": "9738",
	"./confessions.png": "4af6",
	"./criers-war.png": "f652",
	"./dawn.png": "9f7f",
	"./deathless-divide.png": "134b",
	"./dhonielle-clayton.png": "d671",
	"./dolen-perkins-valdez.png": "9f86",
	"./dread-nation.png": "9e91",
	"./emergency-skin.png": "2414",
	"./emma-newman.png": "3756",
	"./erica-armstrong-dunbar.png": "94eb",
	"./erin-e-adams.png": "d4be",
	"./exit-strategy.png": "7a83",
	"./ezra-claytan-daniels.png": "87a4",
	"./faridah-bk-ymd.png": "ce5a",
	"./firekeepers-daughter.png": "1b71",
	"./fledgling.png": "d47d",
	"./fonda-lee.png": "6b25",
	"./fugitive-telemetry.png": "e52d",
	"./full-disclosure.png": "3733",
	"./get-a-life-chloe-brown.png": "b98d",
	"./gilly-segal.png": "7076",
	"./gods-of-jade-and-shadow.png": "8c81",
	"./grown.png": "b0a7",
	"./hallie-rubenhold.png": "d81c",
	"./heartstopper-volume-one.png": "880d",
	"./hench.png": "6eb3",
	"./honore-fanonne-jeffers.png": "ff15",
	"./how-long-til-black-future-month.png": "35df",
	"./im-not-dying-with-you-tonight.png": "af7c",
	"./imago.png": "5c52",
	"./in-the-time-of-the-butterflies.png": "ef89",
	"./iron-heart.png": "1e01",
	"./iron-widow.png": "a5e0",
	"./isabel-wilkerson.png": "e808",
	"./jade-city.png": "3ebc",
	"./james-islington.png": "a862",
	"./jamila-rowser.png": "2824",
	"./jonathan-larson.png": "01ee",
	"./jordan-ifueko.png": "b417",
	"./julia-alvarez.png": "412c",
	"./june-hur.png": "0652",
	"./justin-c-key.png": "9f76",
	"./justina-ireland.png": "5a3e",
	"./kalynn-bayron.png": "4a57",
	"./kanae-minato.png": "4341",
	"./katabasis.png": "a663",
	"./ken-liu.png": "4560",
	"./kiley-reid.png": "19c5",
	"./kim-jiyoung-born-1982.png": "6576",
	"./kim-liggett.png": "0563",
	"./kimberly-jones.png": "b72e",
	"./kindred.png": "83d8",
	"./krystal-marquis.png": "9f19",
	"./lakewood.png": "5477",
	"./ld-lewis.png": "6e7f",
	"./ledgendborn.png": "1c38",
	"./lesley-nneka-arimah.png": "592e",
	"./let-me-hear-a-rhyme.png": "7cf6",
	"./lgbtqa-heart.png": "2a2f",
	"./ling-ling-huang.png": "82f0",
	"./martha-wells.png": "02ff",
	"./maurice-broaddus.png": "9fc3",
	"./megan-giddings.png": "560c",
	"./meredith-katz.png": "13f5",
	"./mind-of-my-mind.png": "8665",
	"./miss-kim-knows-and-other-stories.png": "3c59",
	"./mondays-not-coming.png": "2d2e",
	"./nalo-hopkinson.png": "9b40",
	"./namina-forna.png": "a321",
	"./nana-kwame-adjei-brenyah.png": "769f",
	"./natural-beauty.png": "05de",
	"./nella-larsen.png": "7d67",
	"./network-effect.png": "124c",
	"./nic-stone.png": "968e",
	"./nicola-yoon.png": "35c7",
	"./nicole-d-sconiers.png": "49a0",
	"./night-wherever-we-go.png": "8257",
	"./nina-varela.png": "c41f",
	"./nk-jemisin.png": "206f",
	"./nnedi-okorafor.png": "91b7",
	"./octavia-e-butler.png": "8688",
	"./out-there-screaming-an-anthology-of-new-black-horror.png": "9257",
	"./p-djl-clark.png": "235b",
	"./pamela-nagami-md.png": "07d2",
	"./parable-of-the-sower.png": "b172",
	"./passing.png": "6ae8",
	"./patternmaster.png": "e9c5",
	"./penance.png": "b36f",
	"./philippa-gregory.png": "9b2b",
	"./placeholder-author.png": "56e2",
	"./planetfall.png": "9cc9",
	"./raybearer.png": "2151",
	"./rebecca-roanhorse.png": "55a6",
	"./red-white--royal-blue.png": "0405",
	"./redemptor.png": "28ee",
	"./rf-kuang.png": "62a9",
	"./ring-shout.png": "205b",
	"./rion-amilcar-scott.png": "5b3c",
	"./rivers-solomon.png": "e088",
	"./robyn-smith.png": "5d3d",
	"./rogue-protocol.png": "491d",
	"./rust-in-the-root.png": "40a9",
	"./sarah-andersen.png": "c378",
	"./shades-in-shadow.png": "9915",
	"./she-came-to-slay-the-life-and-times-of-harriet-tubman.png": "726a",
	"./sidik-fofana.png": "08c0",
	"./sierra-greer.png": "f5cf",
	"./silvia-moreno-garcia.png": "48b0",
	"./six-crimson-cranes.png": "b5de",
	"./sohn-won-pyung.png": "7ad9",
	"./stories-from-the-tenants-downstairs.png": "f18b",
	"./such-a-fun-age.png": "4e12",
	"./system-collapse.png": "79bb",
	"./take-my-hand.png": "a76c",
	"./talia-hibbert.png": "b05c",
	"./tananarive-due.png": "4902",
	"./terence-taylor.png": "07aa",
	"./the-awakened-kingdom.png": "4499",
	"./the-black-gods-drums.png": "a92d",
	"./the-boleyn-inheritance.png": "242a",
	"./the-broken-kingdoms.png": "e8cd",
	"./the-burning-god.png": "b5bd",
	"./the-city-we-became.png": "16b2",
	"./the-constant-princess.png": "0f01",
	"./the-cybernetic-tea-shop.png": "2eee",
	"./the-davenports.png": "fb19",
	"./the-death-of-vivek-oji.png": "345a",
	"./the-deep.png": "4961",
	"./the-dragon-republic.png": "971f",
	"./the-fifth-season.png": "e089",
	"./the-five-the-untold-lives-of-the-women-killed-by-jack-the-ripper.png": "7701",
	"./the-gilded-ones.png": "a57a",
	"./the-girl-who-fell-beneath-the-sea.png": "effc",
	"./the-good-luck-girls.png": "cdf6",
	"./the-grace-year.png": "2a98",
	"./the-hidden-girl-and-other-stories.png": "1ebb",
	"./the-hundred-thousand-kingdoms.png": "cbc5",
	"./the-killing-moon.png": "70ce",
	"./the-kingdom-of-gods.png": "efb8",
	"./the-kingmakers-daughter.png": "9055",
	"./the-kings-curse.png": "1432",
	"./the-lady-of-the-rivers.png": "8287",
	"./the-last-tudor.png": "23b6",
	"./the-love-songs-of-web-du-bois.png": "53ca",
	"./the-nickel-boys.png": "42e2",
	"./the-obelisk-gate.png": "e379",
	"./the-other-boleyn-girl.png": "e023",
	"./the-other-queen.png": "e156",
	"./the-poppy-war.png": "1b6b",
	"./the-queens-fool.png": "9b6b",
	"./the-red-palace.png": "deae",
	"./the-red-queen.png": "ee84",
	"./the-shadow-of-the-gods.png": "72be",
	"./the-shadowed-sun.png": "305d",
	"./the-stone-sky.png": "70a4",
	"./the-strength-of-the-few.png": "95c4",
	"./the-sword-of-kaigen.png": "d89d",
	"./the-taming-of-the-queen.png": "9636",
	"./the-testaments.png": "24c3",
	"./the-underground-railroad.png": "b14f",
	"./the-vanishing-half.png": "47a8",
	"./the-virgins-lover.png": "4b09",
	"./the-weight-of-blood.png": "5ac9",
	"./the-white-princess.png": "a914",
	"./the-white-queen.png": "d110",
	"./the-will-of-the-many.png": "af8f",
	"./the-woman-with-a-worm-in-her-head-and-other-true-stories-of-infectious-disease.png": "c14e",
	"./the-world-we-make.png": "d115",
	"./the-year-of-the-witching.png": "3f9d",
	"./there-there.png": "c2a0",
	"./this-poison-heart.png": "e733",
	"./this-wicked-fate.png": "c084",
	"./tick-tick-boom.png": "188f",
	"./tiffany-d-jackson.png": "dab0",
	"./tochi-onyebuchi.png": "ddbd",
	"./tommy-orange.png": "d7cd",
	"./tracey-rose-peyton.png": "2907",
	"./trevor-noah.png": "88af",
	"./uprooted.png": "62ae",
	"./violet-allen.png": "6c03",
	"./wandering-stars.png": "cee0",
	"./wash-day-diaries.png": "8e11",
	"./white-smoke.png": "49ac",
	"./whiteout.png": "010b",
	"./wild-seed.png": "0121",
	"./xiran-jay-zhao.png": "b738",
	"./yellowface.png": "b54a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa71";